import { render, staticRenderFns } from "./ModalRemoveItem.vue?vue&type=template&id=2a3ac7e6&scoped=true"
import script from "./ModalRemoveItem.vue?vue&type=script&lang=js"
export * from "./ModalRemoveItem.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoveItem.vue?vue&type=style&index=0&id=2a3ac7e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ac7e6",
  null
  
)

export default component.exports